import { render, staticRenderFns } from "./gj-upload.vue?vue&type=template&id=4816b3be&scoped=true&"
import script from "./gj-upload.vue?vue&type=script&lang=js&"
export * from "./gj-upload.vue?vue&type=script&lang=js&"
import style0 from "./gj-upload.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./gj-upload.vue?vue&type=style&index=1&id=4816b3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4816b3be",
  null
  
)

export default component.exports